export default{
    
  name: "Dafne Casbah",
  location: "Florida, VA",
  email: "Dancingdafne@kma.com",
  startDate: "6/4/2021",
  lastLogin: "5/3/2021 6:30pm ET"

}